export default {
  asMoney,
  getDayName,
  getMonthName,
  getTime,
  getDatatableLanguageDefinitions,
  sortArrayAsc,
  initDataTable,
  toast,
  validateEmail,
  confirm,
  asNumber,
  exportToCsv,
  message
}

function asMoney(amount) {
  try {
    amount = String(amount).replace('$','').replace(',','');
    let decimalCount = 2;
    let decimal = ".";
    let thousands = ",";
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    console.log(e);
  }
}
function asNumber(amount) {
  try {
    amount = String(amount).replace('$','').replace(',','');
    let decimalCount = 2;
    let decimal = ".";
    let thousands = ",";
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;
    return String(
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(0)
            .slice(2)
        : "")
    ).replace('.','');
  } catch (e) {
    console.log(e);
  }
}
function getDayName(day) {
  //console.log('getDayName ', day);
  let name = "N/D";
  day = String(day);
  switch (day) {
    case "0":
      name = "Domingo";
      break;
    case "1":
      name = "Lunes";
      break;
    case "2":
      name = "Martes";
      break;
    case "3":
      name = "Miercoles";
      break;
    case "4":
      name = "Jueves";
      break;
    case "5":
      name = "Viernes";
      break;
    case "6":
      name = "Sabado";
      break;
  }
  return name;
}
function getMonthName(month) {
  let name = "N/D";
  month = String(month);
  switch (month) {
    case "1":
      name = "Enero";
      break;
    case "2":
      name = "Febrero";
      break;
    case "3":
      name = "Marzo";
      break;
    case "4":
      name = "Abril";
      break;
    case "5":
      name = "Mayo";
      break;
    case "6":
      name = "Junio";
      break;
    case "7":
      name = "Julio";
      break;
    case "8":
      name = "Agosto";
      break;
    case "9":
      name = "Septiembre";
      break;
    case "10":
      name = "Octubre";
      break;
    case "11":
      name = "Noviembre";
      break;
    case "12":
      name = "Diciembre";
      break;
  }
  return name;
}
function getTime(timestamp){
  let d =null;
  if(typeof timestamp !== 'undefined'){
    d = new Date(parseInt(timestamp)) 
  }else{
    d = new Date();
  }
  let meridian = d.getHours() > 12 ? 'PM' : 'AM';
  let seconds = String(d.getSeconds()).length === 1 ? '0'+d.getSeconds() : d.getSeconds();
  let minute = String(d.getMinutes()).length === 1 ? '0'+d.getMinutes() : d.getMinutes();
  let hour = d.getHours() > 12 ? Math.abs(d.getHours() - 12) : d.getHours();

  hour =  String(hour).length === 1 
            ? '0'+hour
            : hour; 

  if(timestamp){
    return `${hour}:${minute}:${seconds} ${meridian}`; 
  }else{
    return `${hour}:${minute} ${meridian}`;
  } 
}
function getDatatableLanguageDefinitions(){
  return {                   
    "sProcessing":     "Procesando...",
    "sLengthMenu":     "Mostrar _MENU_ registros",
    "sZeroRecords":    "No se encontraron resultados",
    "sEmptyTable":     "Ningún dato disponible en esta tabla",
    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
    "sInfoPostFix":    "",
    "sSearch":         "Filtrar:",
    "sUrl":            "",
    "sInfoThousands":  ",",
    "sLoadingRecords": "<h3>Cargando...</h3>",
    "oPaginate": {
        "sFirst":    "Primero",
        "sLast":     "Último",
        "sNext":     "Siguiente",
        "sPrevious": "Anterior"
    },
    "oAria": {
        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
    }
  };
}
function sortArrayAsc(a,b,field){
  field = field || 'name';
  if(a[field] > b[field]){
    return 1;
  }else if(a[field] < b[field]){
    return -1;
  }else{
    return 0;
  }
}
function initDataTable(tableId, fileTitle, sort, sortOrder){
  sortOrder = sortOrder || 'asc';
  fileTitle = fileTitle || 'SnowEats - Descarga';
  return $('#'+tableId).DataTable( {
    dom: 'Bfrtip',
    paginate: true,
    scrollY: '50vh',
    order: [[ 0, sortOrder ]],
    language: getDatatableLanguageDefinitions(),
    buttons: [
      {
        extend: 'excelHtml5',
        title: fileTitle,
        text: 'Exportar a excel'
      },
    ]
  } );  
}
function toast(title, type){
  type = type || 'success';
  title = title || 'Mensaje sin titulo';

  Swal
  .mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
  })
  .fire({
    type: type,
    title: title
  });  
}
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function confirm(message, noCancelButon){
  return new Promise((resolve, reject) => {
    Swal
    .fire({
      title: 'Estas seguro?',
      text: message || "Este dato sera eliminado",
      type: 'warning',
      showCancelButton: noCancelButon ? false : true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: '<i class="fa fa-close"></i> No',
      confirmButtonText: '<i class="fa fa-check"></i> Si',
      backdrop: false,
      reverseButtons: true
    })
    .then(result => resolve(result.value))
    .catch(e => reject(e));;
  });
}
function exportToCsv(filename, rows) {
  var processRow = function (row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString();
          if (row[j] instanceof Date) {
              innerValue = row[j].toLocaleString();
          };
          var result = innerValue.replace(/"/g, '""');
          if (result.search(/("|,|\n)/g) >= 0)
              result = '"' + result + '"';
          if (j > 0)
              finalVal += ',';
          finalVal += result;
      }
      return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
  } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
  }
}
function message(title, message, type){
  return new Promise((resolve, reject) => {
    Swal
    .fire({
      title: title,
      text: message,
      type: type || 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
    .then(result => resolve(result.value))
    .catch(e => reject(e));;
  });
}
